window.OSM = window.OSM ?? {};
/**
 * @type {IMapsProps}
 */
OSM.MapConfigs = OSM.MapConfigs ?? {}

/**
 * See MapCoreConfig.js for working example
 * @type {IMapProps}
 */
OSM.MapConfigs.location_layout = {
    cluster: {


        marker: {
            lngLat: [0, 0],
            iconProps: {
                imagePath: "/app/themes/hailstone/img/logo/png-logo/icon-logo.png",
                imageIconOrigin: [0, 0],
                scale: 0.1
            }
        },
        clusterIcon: {
            /**
             *
             * @param itemCount {number}
             */
            getColor: (itemCount) =>
            {
                if(itemCount >= 10){
                    return "#9678D3"
                }
                return "#26213F"
            },
            /**
             *
             * @param itemCount {number}
             */
            getStrokeColor: (itemCount) =>
            {
                if(itemCount >= 10){
                    return "#26213F"
                }
                return "#9678D3"
            },
            /**
             *
             * @param itemCount {number}
             */
            getTextColor: (itemCount) =>
            {
                if(itemCount >= 10){
                    return "#26213F"
                }
                return "#ffffff"
            }
        }
    }
}
